import React from 'react';
import { Shield, Check } from 'lucide-react';
export function Hero() {
  return <section className="relative flex flex-col items-center justify-center px-4 md:px-12 lg:px-24 py-10 md:py-16 overflow-hidden" data-id="element-148">
      {/* Background ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-cyan-neon/5 rounded-full blur-[120px] pointer-events-none" data-id="element-149"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10 flex flex-col items-center" data-id="element-150">
        <h1 className="font-bebas text-5xl md:text-7xl lg:text-8xl uppercase tracking-wide leading-[0.9] mb-8 flex flex-col items-center" data-id="element-151">
          <span className="text-white block mb-2" data-id="element-152">
            PARA HOMBRES QUE QUIEREN DEJAR LA PORNOGRAFÍA PERO NO PUEDEN...
          </span>

          <span className="block mt-4 text-[32px] text-[#00F2FF]" data-id="element-153">
            ELIMINA LA ADICCIÓN EN LAS PRÓXIMAS 24 HORAS
          </span>
        </h1>

        <p className="font-inter text-lg md:text-xl text-text-muted max-w-2xl mx-auto mb-6 leading-relaxed" data-id="element-154">
          "Confiado por 9,000 hombres: Padres, CEOs, líderes"{' '}
          <strong className="text-white font-bold" data-id="element-155">
            Este método sencillo ataca patrones profundamente arraigados que la
            fuerza de voluntad no puede modificar.
          </strong>
        </p>

        <div className="relative w-full max-w-2xl mx-auto mb-12 rounded-2xl overflow-hidden" data-id="element-156">
          <img src="https://cdn.magicpatterns.com/uploads/44aQLHDu4U4t8ZKeJSN6nL/private_openrouter-generated-image-1774627634894.png" alt="Hombre en la cama mirando el teléfono en la madrugada" className="w-full h-auto rounded-2xl" data-id="element-157" />
          <div className="absolute inset-0 bg-gradient-to-t from-deep-black/60 to-transparent rounded-2xl" data-id="element-158"></div>
        </div>
        <a href="#pricing" className="btn-3d-glow px-8 py-5 text-lg md:text-xl w-full sm:w-auto min-w-[320px] group animate-pulse hover:animate-none" data-id="element-159">
          SÍ, ACTIVAR MI BLINDAJE AHORA <Shield className="ml-3 w-6 h-6" data-id="element-160" />
        </a>
        <br data-id="element-161" />
        <p className="font-inter text-lg md:text-xl max-w-2xl mx-auto mb-6 leading-relaxed text-[#F9FAFD]" data-id="element-162">
          "Más de 9,000 hombres: Padres, CEOs, líderes"
        </p>
        <div className="w-full max-w-2xl mx-auto mb-12 rounded-2xl overflow-hidden" data-id="element-163">
          <img src="https://cdn.magicpatterns.com/uploads/bovfWZEjDzLnauGGqxsfM4/TODOS_MAS_LA_REPORGRAMACION.png" alt="El Protocolo de Blindaje - Paquete completo con audiolibro y bonus" className="w-full h-auto rounded-2xl" data-id="element-164" />
        </div>
        <p className="text-white font-semibold text-xl border-l-4 border-alert-red pl-4 py-1 text-left" data-id="element-165">
          ESTO ES LO QUE RECIBES HOY:
        </p>
        <ul className="space-y-4 mb-8 flex-1 font-inter text-sm text-text-muted " data-id="element-166">
          <li className="flex items-start gap-3" data-id="element-167">
            <Check className="w-5 h-5 text-cyan-neon shrink-0" data-id="element-168" />
            <span data-id="element-169">Protocolo de Blindaje (PDF)</span>
          </li>
          <li className="flex items-start gap-3" data-id="element-170">
            <Check className="w-5 h-5 text-cyan-neon shrink-0" data-id="element-171" />
            <span data-id="element-172">Audiolibro Completo (MP3)</span>
          </li>
          <li className="flex items-start gap-3" data-id="element-173">
            <Check className="w-5 h-5 text-cyan-neon shrink-0" data-id="element-174" />
            <span data-id="element-175">Auxilio 60s (PDF)</span>
          </li>
          <li className="flex items-start gap-3" data-id="element-176">
            <Check className="w-5 h-5 text-cyan-neon shrink-0" data-id="element-177" />
            <span data-id="element-178">Mapa de Disparadores (PDF) </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-179">
            <Check className="w-5 h-5 text-cyan-neon shrink-0" data-id="element-180" />
            <span data-id="element-181">Restauración V10 (Guía) </span>
          </li>
        </ul>
        <h3 className="font-bebas tracking-wide mb-2 text-[38px] text-[#00F2FF]" data-id="element-182">
          SOLO POR HOY
        </h3>
        <div className="flex items-baseline gap-2" data-id="element-183">
          <span className="font-bebas text-white text-[64px]" data-id="element-184">$19.99</span>
          <span className="text-text-muted font-inter text-sm" data-id="element-185">USD</span>
        </div>
        <p className="font-inter text-sm text-text-muted tracking-wide " data-id="element-186">
          <strong className="text-white font-bold" data-id="element-187">
            Un solo pago | Acceso inmediato
          </strong>
        </p>
        <br data-id="element-188" />
        <a href="#pricing" className="btn-3d-glow px-8 py-5 text-lg md:text-xl w-full sm:w-auto min-w-[320px] group animate-pulse hover:animate-none" data-id="element-189">
          SÍ, ACTIVAR MI BLINDAJE AHORA <Shield className="ml-3 w-6 h-6" data-id="element-190" />
        </a>
        <br data-id="element-191" />
        <p className="font-inter text-sm text-text-muted tracking-wide " data-id="element-192">
          <strong className="text-white font-regular text-[12px]" data-id="element-193">
            Pago 100% seguro mediante cifrado de 256 bits
          </strong>
        </p>
        <div className="mt-4 mb-4 border border-cyan-neon/40 rounded-lg px-6 py-3 bg-cyan-neon/5 max-w-xl" data-id="element-194">
          <p className="font-inter text-sm text-white leading-relaxed text-center" data-id="element-195">
            Respaldado por nuestra garantía de devolución de dinero del 100%:{' '}
            <strong className="text-cyan-neon" data-id="element-196">
              "Libérese o recupere su inversión"
            </strong>
            .
          </p>
          {/* Payment method icons */}
          <div className="flex items-center justify-center gap-3 mt-3" data-id="element-197">
            {/* Visa */}
            <div className="bg-white rounded px-2 py-1 flex items-center justify-center h-7" data-id="element-198">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 32" className="h-5 w-auto" data-id="element-199">
                <rect width="48" height="32" rx="4" fill="#fff" data-id="element-200" />
                <path d="M19.5 21h-3l1.9-11.5h3L19.5 21zm12.3-11.2c-.6-.2-1.5-.5-2.7-.5-3 0-5.1 1.5-5.1 3.7 0 1.6 1.5 2.5 2.6 3.1 1.2.6 1.6.9 1.6 1.4 0 .8-.9 1.1-1.8 1.1-1.2 0-1.9-.2-2.9-.6l-.4-.2-.4 2.5c.7.3 2.1.6 3.5.6 3.2 0 5.2-1.5 5.2-3.8 0-1.3-.8-2.3-2.5-3.1-1-.5-1.7-.9-1.7-1.4 0-.5.5-1 1.7-1 1 0 1.7.2 2.2.4l.3.1.4-2.3zm7.9-.3h-2.3c-.7 0-1.3.2-1.6 1l-4.4 10.5h3.2l.6-1.7h3.8l.4 1.7H42l-2.3-11.5zm-3.6 7.4l1.6-4.2.4 2.1.6 2.1h-2.6zM16.2 9.5l-3 7.9-.3-1.5c-.5-1.8-2.2-3.8-4.1-4.8l2.7 10h3.2l4.8-11.6h-3.3z" fill="#1A1F71" data-id="element-201" />
                <path d="M10.1 9.5H5.1l-.1.3c3.8.9 6.3 3.2 7.3 5.9l-1.1-5.2c-.2-.8-.7-1-1.1-1z" fill="#F9A533" data-id="element-202" />
              </svg>
            </div>
            {/* Mastercard */}
            <div className="bg-white rounded px-2 py-1 flex items-center justify-center h-7" data-id="element-203">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 32" className="h-5 w-auto" data-id="element-204">
                <rect width="48" height="32" rx="4" fill="#fff" data-id="element-205" />
                <circle cx="19" cy="16" r="9" fill="#EB001B" data-id="element-206" />
                <circle cx="29" cy="16" r="9" fill="#F79E1B" data-id="element-207" />
                <path d="M24 9.3a9 9 0 0 1 3.3 6.7 9 9 0 0 1-3.3 6.7 9 9 0 0 1-3.3-6.7A9 9 0 0 1 24 9.3z" fill="#FF5F00" data-id="element-208" />
              </svg>
            </div>
            {/* Amex */}
            <div className="bg-[#006FCF] rounded px-2 py-1 flex items-center justify-center h-7" data-id="element-209">
              <span className="text-white font-bold text-[10px] tracking-tight leading-none" data-id="element-210">
                AMEX
              </span>
            </div>
            {/* PayPal */}
            <div className="bg-white rounded px-2 py-1 flex items-center justify-center h-7" data-id="element-211">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 32" className="h-5 w-auto" data-id="element-212">
                <rect width="48" height="32" rx="4" fill="#fff" data-id="element-213" />
                <path d="M18.5 24.5h-2.3c-.2 0-.3-.1-.3-.3l.1-.5 1.5-9.5c0-.2.2-.3.3-.3h3.4c1.1 0 2 .1 2.7.4.7.3 1.2.8 1.4 1.5.3.7.3 1.6.1 2.6-.2 1.1-.6 2-1.2 2.7-.6.7-1.3 1.2-2.1 1.5-.8.3-1.7.4-2.7.4h-.6c-.4 0-.7.3-.8.7l-.5 1.8z" fill="#253B80" data-id="element-214" />
                <path d="M33.5 14.2c-.2 1.1-.6 2-1.2 2.7-.6.7-1.3 1.2-2.1 1.5-.8.3-1.7.4-2.7.4h-.6c-.4 0-.7.3-.8.7l-.7 2.5-.2 1.3c0 .2.1.3.3.3h2.1c.2 0 .3-.1.3-.3l.5-3c.1-.4.4-.7.8-.7h.6c1 0 1.9-.1 2.7-.4.8-.3 1.5-.8 2.1-1.5.6-.7 1-1.6 1.2-2.7.2-1 .2-1.9-.1-2.6-.1-.3-.3-.5-.5-.7-.5.8-1.2 1.5-2.1 2-.3.2-.5.3-.6.5z" fill="#179BD7" data-id="element-215" />
              </svg>
            </div>
          </div>
        </div>
        <br data-id="element-216" />
        <p className="font-inter text-lg md:text-xl text-text-muted max-w-2xl mx-auto mb-4 leading-relaxed" data-id="element-217">
          No eres débil.
          <strong className="text-white font-bold" data-id="element-218">
            Tu cerebro fue hackeado por la sobreestimulación
          </strong>
          . Deja de pelear con 'fuerza de voluntad' e instala un sistema de
          respuesta inmediata.
        </p>
      </div>
    </section>;
}